import { DirectoryTableProps, Table } from '@atlas-frontend/sdk';
import { createColumnHelper } from '@tanstack/react-table';
import { FC, useMemo } from 'react';

type OutputDataType = Record<string, any>;
const columnHelper = createColumnHelper<OutputDataType>();

export const TestCalculationOutputDataTable: FC<
  DirectoryTableProps<OutputDataType> & {
    initialData: OutputDataType[];
    data: OutputDataType[];
  }
> = (props) => {
  const { initialData } = props;
  const columns = useMemo(
    () =>
      Object.keys(initialData[0] || {}).map((key) =>
        columnHelper.accessor(key, {
          header: key,
        }),
      ),
    [initialData],
  );

  return (
    <Table
      {...props}
      columns={columns}
      name="test-calculation-output-data-table"
      sticky
      scrollContainerSelector="#output-test-calculation-report-main-content"
      virtual
    />
  );
};
